[
  {
    "id": "board-bosque-1",
    "rows": [
      {
        "y": 0.22,
        "bars": [
          { "kind": "mult", "value": 2, "x": 0.18, "width": 0.2 },
          { "kind": "mult", "value": 3, "x": 0.5, "width": 0.2 },
          { "kind": "mult", "value": 2, "x": 0.82, "width": 0.2 }
        ]
      },
      {
        "y": 0.48,
        "bars": [
          { "kind": "mystery", "x": 0.32, "width": 0.18 },
          { "kind": "mult", "value": 4, "x": 0.66, "width": 0.2 }
        ]
      },
      {
        "y": 0.74,
        "bars": [
          { "kind": "trampoline", "x": 0.2, "width": 0.16 },
          { "kind": "mult", "value": 5, "x": 0.52, "width": 0.2 },
          { "kind": "mult", "value": 2, "x": 0.82, "width": 0.18 }
        ]
      }
    ]
  },
  {
    "id": "board-bosque-2",
    "rows": [
      {
        "y": 0.18,
        "bars": [
          { "kind": "mult", "value": 3, "x": 0.24, "width": 0.2 },
          { "kind": "mult", "value": 6, "x": 0.6, "width": 0.2 }
        ]
      },
      {
        "y": 0.42,
        "bars": [
          { "kind": "mystery", "x": 0.16, "width": 0.18 },
          { "kind": "mult", "value": 2, "x": 0.44, "width": 0.18 },
          { "kind": "mystery", "x": 0.72, "width": 0.18 }
        ]
      },
      {
        "y": 0.64,
        "bars": [
          { "kind": "trampoline", "x": 0.34, "width": 0.16 },
          { "kind": "mult", "value": 7, "x": 0.66, "width": 0.2 }
        ]
      },
      {
        "y": 0.85,
        "bars": [
          { "kind": "mult", "value": 3, "x": 0.28, "width": 0.2 },
          { "kind": "mult", "value": 4, "x": 0.62, "width": 0.2 }
        ]
      }
    ]
  },
  {
    "id": "board-bosque-3",
    "rows": [
      {
        "y": 0.2,
        "bars": [
          { "kind": "mult", "value": 2, "x": 0.16, "width": 0.18 },
          { "kind": "mult", "value": 4, "x": 0.44, "width": 0.18 },
          { "kind": "mult", "value": 3, "x": 0.74, "width": 0.18 }
        ]
      },
      {
        "y": 0.46,
        "bars": [
          { "kind": "trampoline", "x": 0.24, "width": 0.16 },
          { "kind": "mystery", "x": 0.52, "width": 0.18 },
          { "kind": "mult", "value": 5, "x": 0.82, "width": 0.16 }
        ]
      },
      {
        "y": 0.72,
        "bars": [
          { "kind": "mult", "value": 6, "x": 0.36, "width": 0.2 },
          { "kind": "mult", "value": 3, "x": 0.7, "width": 0.2 }
        ]
      }
    ]
  },
  {
    "id": "board-oeste-1",
    "rows": [
      {
        "y": 0.18,
        "bars": [
          { "kind": "mult", "value": 3, "x": 0.2, "width": 0.18 },
          { "kind": "mult", "value": 5, "x": 0.5, "width": 0.18 },
          { "kind": "mult", "value": 3, "x": 0.8, "width": 0.18 }
        ]
      },
      {
        "y": 0.42,
        "bars": [
          { "kind": "mystery", "x": 0.3, "width": 0.18 },
          { "kind": "mult", "value": 6, "x": 0.64, "width": 0.2 }
        ]
      },
      {
        "y": 0.66,
        "bars": [
          { "kind": "trampoline", "x": 0.22, "width": 0.16 },
          { "kind": "mult", "value": 4, "x": 0.5, "width": 0.18 },
          { "kind": "mult", "value": 7, "x": 0.8, "width": 0.16 }
        ]
      },
      {
        "y": 0.87,
        "bars": [
          { "kind": "mult", "value": 4, "x": 0.34, "width": 0.2 },
          { "kind": "mystery", "x": 0.68, "width": 0.18 }
        ]
      }
    ]
  },
  {
    "id": "board-oeste-2",
    "rows": [
      {
        "y": 0.2,
        "bars": [
          { "kind": "mult", "value": 4, "x": 0.22, "width": 0.18 },
          { "kind": "mystery", "x": 0.52, "width": 0.18 },
          { "kind": "mult", "value": 5, "x": 0.82, "width": 0.16 }
        ]
      },
      {
        "y": 0.44,
        "bars": [
          { "kind": "trampoline", "x": 0.18, "width": 0.14 },
          { "kind": "mult", "value": 7, "x": 0.46, "width": 0.2 },
          { "kind": "mult", "value": 3, "x": 0.78, "width": 0.18 }
        ]
      },
      {
        "y": 0.68,
        "bars": [
          { "kind": "mystery", "x": 0.32, "width": 0.18 },
          { "kind": "mult", "value": 6, "x": 0.66, "width": 0.2 }
        ]
      },
      {
        "y": 0.88,
        "bars": [
          { "kind": "mult", "value": 5, "x": 0.3, "width": 0.2 },
          { "kind": "mult", "value": 4, "x": 0.66, "width": 0.2 }
        ]
      }
    ]
  },
  {
    "id": "board-oeste-3",
    "rows": [
      {
        "y": 0.16,
        "bars": [
          { "kind": "mult", "value": 5, "x": 0.28, "width": 0.18 },
          { "kind": "mult", "value": 6, "x": 0.64, "width": 0.18 }
        ]
      },
      {
        "y": 0.4,
        "bars": [
          { "kind": "mystery", "x": 0.2, "width": 0.16 },
          { "kind": "trampoline", "x": 0.48, "width": 0.14 },
          { "kind": "mystery", "x": 0.76, "width": 0.16 }
        ]
      },
      {
        "y": 0.64,
        "bars": [
          { "kind": "mult", "value": 7, "x": 0.34, "width": 0.2 },
          { "kind": "mult", "value": 4, "x": 0.7, "width": 0.2 }
        ]
      },
      {
        "y": 0.85,
        "bars": [
          { "kind": "mult", "value": 6, "x": 0.5, "width": 0.24 }
        ]
      }
    ]
  },
  {
    "id": "board-cripta-1",
    "rows": [
      {
        "y": 0.18,
        "bars": [
          { "kind": "mult", "value": 4, "x": 0.2, "width": 0.16 },
          { "kind": "negative", "x": 0.5, "width": 0.16 },
          { "kind": "mult", "value": 5, "x": 0.8, "width": 0.16 }
        ]
      },
      {
        "y": 0.42,
        "bars": [
          { "kind": "mystery", "x": 0.3, "width": 0.16 },
          { "kind": "mult", "value": 7, "x": 0.64, "width": 0.18 }
        ]
      },
      {
        "y": 0.66,
        "bars": [
          { "kind": "trampoline", "x": 0.22, "width": 0.14 },
          { "kind": "mult", "value": 5, "x": 0.5, "width": 0.18 },
          { "kind": "negative", "x": 0.8, "width": 0.14 }
        ]
      },
      {
        "y": 0.87,
        "bars": [
          { "kind": "mult", "value": 6, "x": 0.34, "width": 0.2 },
          { "kind": "mystery", "x": 0.68, "width": 0.16 }
        ]
      }
    ]
  },
  {
    "id": "board-cripta-2",
    "rows": [
      {
        "y": 0.2,
        "bars": [
          { "kind": "negative", "x": 0.18, "width": 0.14 },
          { "kind": "mult", "value": 6, "x": 0.46, "width": 0.18 },
          { "kind": "mult", "value": 4, "x": 0.78, "width": 0.16 }
        ]
      },
      {
        "y": 0.44,
        "bars": [
          { "kind": "mystery", "x": 0.28, "width": 0.16 },
          { "kind": "mult", "value": 7, "x": 0.6, "width": 0.18 },
          { "kind": "negative", "x": 0.86, "width": 0.12 }
        ]
      },
      {
        "y": 0.68,
        "bars": [
          { "kind": "trampoline", "x": 0.32, "width": 0.14 },
          { "kind": "mult", "value": 5, "x": 0.64, "width": 0.18 }
        ]
      },
      {
        "y": 0.88,
        "bars": [
          { "kind": "mult", "value": 6, "x": 0.3, "width": 0.2 },
          { "kind": "mult", "value": 5, "x": 0.66, "width": 0.2 }
        ]
      }
    ]
  },
  {
    "id": "board-cripta-3",
    "rows": [
      {
        "y": 0.16,
        "bars": [
          { "kind": "mult", "value": 5, "x": 0.22, "width": 0.16 },
          { "kind": "negative", "x": 0.5, "width": 0.14 },
          { "kind": "mult", "value": 7, "x": 0.78, "width": 0.16 }
        ]
      },
      {
        "y": 0.4,
        "bars": [
          { "kind": "mystery", "x": 0.18, "width": 0.16 },
          { "kind": "mult", "value": 6, "x": 0.48, "width": 0.18 },
          { "kind": "mystery", "x": 0.8, "width": 0.16 }
        ]
      },
      {
        "y": 0.64,
        "bars": [
          { "kind": "negative", "x": 0.28, "width": 0.14 },
          { "kind": "trampoline", "x": 0.54, "width": 0.14 },
          { "kind": "mult", "value": 7, "x": 0.82, "width": 0.14 }
        ]
      },
      {
        "y": 0.86,
        "bars": [
          { "kind": "mult", "value": 6, "x": 0.4, "width": 0.22 },
          { "kind": "mult", "value": 5, "x": 0.74, "width": 0.18 }
        ]
      }
    ]
  },
  {
    "id": "board-volcan-1",
    "rows": [
      {
        "y": 0.18,
        "bars": [
          { "kind": "mult", "value": 6, "x": 0.24, "width": 0.16, "moving": { "speed": 0.6, "range": 0.12 } },
          { "kind": "negative", "x": 0.56, "width": 0.14 },
          { "kind": "mult", "value": 5, "x": 0.82, "width": 0.16 }
        ]
      },
      {
        "y": 0.42,
        "bars": [
          { "kind": "mystery", "x": 0.3, "width": 0.16 },
          { "kind": "mult", "value": 7, "x": 0.64, "width": 0.16, "moving": { "speed": 0.8, "range": 0.1 } }
        ]
      },
      {
        "y": 0.66,
        "bars": [
          { "kind": "trampoline", "x": 0.24, "width": 0.14 },
          { "kind": "negative", "x": 0.52, "width": 0.14 },
          { "kind": "mult", "value": 7, "x": 0.8, "width": 0.16 }
        ]
      },
      {
        "y": 0.87,
        "bars": [
          { "kind": "mult", "value": 6, "x": 0.38, "width": 0.2, "moving": { "speed": 0.5, "range": 0.14 } },
          { "kind": "mult", "value": 5, "x": 0.72, "width": 0.18 }
        ]
      }
    ]
  },
  {
    "id": "board-volcan-2",
    "rows": [
      {
        "y": 0.16,
        "bars": [
          { "kind": "negative", "x": 0.2, "width": 0.14 },
          { "kind": "mult", "value": 7, "x": 0.5, "width": 0.16, "moving": { "speed": 0.9, "range": 0.14 } },
          { "kind": "negative", "x": 0.8, "width": 0.14 }
        ]
      },
      {
        "y": 0.4,
        "bars": [
          { "kind": "mystery", "x": 0.26, "width": 0.16 },
          { "kind": "mult", "value": 6, "x": 0.58, "width": 0.16 },
          { "kind": "mystery", "x": 0.86, "width": 0.14 }
        ]
      },
      {
        "y": 0.64,
        "bars": [
          { "kind": "trampoline", "x": 0.3, "width": 0.14, "moving": { "speed": 0.7, "range": 0.12 } },
          { "kind": "mult", "value": 7, "x": 0.66, "width": 0.18 }
        ]
      },
      {
        "y": 0.86,
        "bars": [
          { "kind": "mult", "value": 6, "x": 0.34, "width": 0.2 },
          { "kind": "negative", "x": 0.66, "width": 0.14 },
          { "kind": "mult", "value": 5, "x": 0.88, "width": 0.12 }
        ]
      }
    ]
  },
  {
    "id": "board-volcan-3",
    "rows": [
      {
        "y": 0.16,
        "bars": [
          { "kind": "mult", "value": 7, "x": 0.28, "width": 0.16, "moving": { "speed": 1, "range": 0.16 } },
          { "kind": "negative", "x": 0.62, "width": 0.16 }
        ]
      },
      {
        "y": 0.38,
        "bars": [
          { "kind": "mystery", "x": 0.2, "width": 0.14 },
          { "kind": "mult", "value": 7, "x": 0.5, "width": 0.16 },
          { "kind": "mystery", "x": 0.8, "width": 0.14 }
        ]
      },
      {
        "y": 0.6,
        "bars": [
          { "kind": "negative", "x": 0.26, "width": 0.14 },
          { "kind": "trampoline", "x": 0.54, "width": 0.14, "moving": { "speed": 0.8, "range": 0.14 } },
          { "kind": "mult", "value": 7, "x": 0.84, "width": 0.14 }
        ]
      },
      {
        "y": 0.84,
        "bars": [
          { "kind": "mult", "value": 6, "x": 0.36, "width": 0.2, "moving": { "speed": 0.6, "range": 0.16 } },
          { "kind": "mult", "value": 7, "x": 0.72, "width": 0.18 }
        ]
      }
    ]
  }
]
